import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export interface SearchedKeyword {
  id: number
  keyword: string
}

/**
 * Hook to search keywords by text match
 *
 * @param query - Search text (minimum 2 characters)
 * @param enabled - Whether the query should run
 * @returns Query result with matching keywords
 */
export const useKeywordSearch = (query: string, enabled: boolean = true) => {
  const fetchWithAuth = useFetchWithAuth()

  const searchKeywords: QueryFunction<SearchedKeyword[]> = async () => {
    const response = await fetchWithAuth(
      `${URL}/keywords/search?q=${encodeURIComponent(query)}&limit=50`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }
    )
    return response
  }

  return useQuery({
    queryKey: ['keywordSearch', query] as const,
    queryFn: searchKeywords,
    enabled: enabled && query.length >= 2,
    staleTime: 30 * 1000, // Cache for 30 seconds
  })
}
